import React from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';

import { getPreviewFormShimmerStyles } from './styles/preview-form-shimmer-styles';

const SummaryItemShimmer = () => {
  const classes = useDefaultStyles(getPreviewFormShimmerStyles);

  return (
    <div className={classNames(classes.summaryItem, 'summary-item-shimmer')}>
      <div className={classes.itemTitle}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '20px', width: '100%' }} /> </Skeleton>
      </div>
      <div className={classes.itemDetail}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '20px', width: '100%' }} /> </Skeleton>
      </div>
    </div>
  );
};

export const PreviewFormShimmer = () => {
  const classes = useDefaultStyles(getPreviewFormShimmerStyles);

  return (
    <div className={classNames(classes.container, 'preview-form-shimmer')}>
      <div className={classNames(classes.header, 'shimmer-header')}>
        <div className={classNames(classes.title, 'shimmer-title')}>
          <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px', width: '180px' }} /> </Skeleton>
        </div>
        <div className={classNames(classes.button, 'shimmer-button')}>
          <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px', width: '96px' }} /> </Skeleton>
        </div>
      </div>
      <div className={classNames(classes.summary, 'preview-panel-summary')}>
        <SummaryItemShimmer />
        <SummaryItemShimmer />
        <SummaryItemShimmer />
      </div>
    </div>
  );
};
